module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1245.78347a6a.jpg";